import React from 'react';

export default class ErrorBoundary extends React.Component<any,any> {
    constructor(props) {
      super(props);
      this.state = { 
          error: null 
        };
    }
  
    // static getDerivedStateFromError(error) {
    //   return { hasError: true };
    // }
  
    componentDidCatch(error, errorInfo) {
        console.log(error);
        this.setState({error:error})
    }
  
    render() {
      if (this.state.error) {
        // You can render any custom fallback UI
        return <h1>Leider ist etwas schief gelaufen</h1>;
      }
  
      return this.props.children; 
    }
  }